import {method} from './core';

export function changePasswordManager(data) {
  return method('admin/managers/change-password', data);
}
export function addManager(data) {
  return method('admin/managers/add', data);
}

export function removeManager(id) {
  return method('admin/managers/remove', { id });
}


export function getManagers() {
  return method('admin/managers/get', {});
}


export function orderUpClients(page, numbers) {
  return method('cars/order-up', { numbers, page });
}

export function updateMany(page, ids, data) {
  return method('cars/update-many', { page, ids, ...data });
}


export function reorderClient(page, from, to) {
  return method('cars/reorder', { page, from, to });
}

export function reorderMany(page, ids, to) {
  return method('cars/reorder-many', { page, ids, to });
}


export function exportCars(numbers, type) {
  return method('cars/export', { numbers, type});
}

export function moveCars(numbers, from, to) {
  return method('cars/move', { numbers, from, to });
}

export function fcheckRequestCar(number) {
  return method('cars/req/fcheck', { number });
}

export function removeRequestCars(cids) {
  return method('cars/req/remove', { cids });
}

export function addRequestCar(number, data) {
  return method('cars/req/add', { number, ...data });
}

export function editRequestCar(id, data) {
  return method('cars/req/edit', { id, ...data });
}


export function fcheckArchiveCar(number) {
  return method('cars/arc/fcheck', { number });
}

export function removeArchiveCars(cids) {
  return method('cars/arc/remove', { cids });
}

export function addArchiveCar(number, data) {
  return method('cars/arc/add', { number, ...data });
}

export function editArchiveCar(id, data) {
  return method('cars/arc/edit', { id, ...data });
}

export function setSendSms(type, numbers, state) {
  return method('cars/set-sms', { type, numbers, state });
}


export function fcheck(number) {
  return method('cars/fcheck', { number });
}

export function removeCars(cids) {
  return method('cars/remove', { cids });
}

export function addCar(number, data) {
  return method('cars/add', { number, ...data });
}

export function editCar(id, data) {
  return method('cars/edit', { id, ...data });
}

export function stateCar(number) {
  return method('cars/state', { number });
}

export function saveSettings(settings) {
  return method('settings/update', { settings });
}

export function getAllClients() {
  return method('cars/get');
}

export function userState() {
  return method('state', {});
}

export function changePassword(password, newPassword) {
  return method('auth/change-password', { password, newPassword });
}

export function login(email, password) {
  return method('login', { email, password });
}

export function userCarsGet() {
  return method('user/cars/get');
}

export function userCarsState(number) {
  return method('user/cars/state', { number });
}

export function userCarsAdd(data) {
  return method('user/cars/add', data);
}

export function userCarsEdit(data) {
  return method('user/cars/edit', data);
}

export function userCarsCheck(number) {
  return method('user/cars/fcheck', { number });
}

export function userCarsRemove(cids) {
  return method('user/cars/remove', { cids });
}

export function userCarsExport(numbers) {
  return method('user/cars/export', { numbers });
}

export function userCarsReorder(from, to) {
  return method('user/cars/reorder', { from, to });
}

export function userCarsOrderUp(numbers) {
  return method('user/cars/order-up', { numbers });
}



export function sign(data) {
  return method('sign', data, 'sign-in');
}

export function signConfirm(code) {
  return method('sign/confirm', { code }, 'sign-confirm');
}

export function signResend() {
  return method('sign/resend', {}, 'sign-resend');
}



// WEBPACK FOOTER //
// ./src/helpers/api/index.js